import React, { useState, useEffect, useRef } from 'react'
import * as THREE from "three";
import GLOBE from 'vanta/dist/vanta.globe.min'

const Vanta = (props) => {
    const [vantaEffect, setVantaEffect] = useState(0)
    const myRef = useRef(null)
    useEffect(() => {
        if (!vantaEffect) {
            setVantaEffect(GLOBE({
                el: myRef.current,
                THREE: THREE,
                mouseControls: true,
                touchControls: true,
                gyroControls: false,
                minHeight: 200.00,
                minWidth: 200.00,
                scale: 1.00,
                scaleMobile: 1.00
            }))
        }
        return () => {
            if (vantaEffect) vantaEffect.destroy()
        }
    }, [vantaEffect])



    return <div style={{ height: "100vh", width: "100%" }} ref={myRef}>
        {props.children}
    </div>
}

export default Vanta